import * as React from "react";

import i18next from "i18next";

import { Nav, StyledNavLink } from "./styles";

const ManageTenantsNavItem = () => {
  return (
    <Nav.Item>
      <StyledNavLink to="/manage-tenants">{i18next.t("tenants")}</StyledNavLink>
    </Nav.Item>
  );
};

export default ManageTenantsNavItem;
